// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Radio-module__root--n6qb3 {
  --radio-indicator-width: 22px;
  --radio-indicator-height: 22px;
  --radio-unchecked-size: 14px;
  --radio-checked-size: 12px;
  --radio-checked-color: var(--chaek-color-text-primary);

  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--chaek-color-text-primary);
  cursor: pointer;
}

.Radio-module__variant-accent--f4ULR {
  --radio-checked-color: var(--chaek-color-text-accent);
}

.Radio-module__size-large--crMnS {
  --radio-unchecked-size: 22px;
  --radio-checked-size: 22px;
}

.Radio-module__is-boxed--hYNih {
  --radio-indicator-width: 24px;
  --radio-indicator-height: 30px;

  box-sizing: border-box;
  height: 50px;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 15px;
  background-color: var(--chaek-color-surface-subtle);
  font-family: var(--chaek-font-family-gowun-dodum);
  font-size: 14px;
  line-height: 21px;
  letter-spacing: -0.150390625px;
}

.Radio-module__is-boxed--hYNih + .Radio-module__is-boxed--hYNih {
  margin-top: 16px;
}

.Radio-module__is-block--Dkab7 {
  display: flex;
}

.Radio-module__input--B6HTm {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  margin: -1px;
  clip: rect(0, 0, 0, 0);
  clip-path: inset(50%);
  overflow: hidden;
  white-space: nowrap;
}

.Radio-module__indicator--Ektu7 {
  position: relative;
  box-sizing: border-box;
  display: inline-flex;
  width: var(--radio-indicator-width);
  height: var(--radio-indicator-height);
  flex: 0 0 var(--radio-indicator-width);
  align-items: center;
  justify-content: center;
}

.Radio-module__input--B6HTm:not(:checked) + .Radio-module__indicator--Ektu7::before {
  box-sizing: border-box;
  width: var(--radio-unchecked-size);
  height: var(--radio-unchecked-size);
  border: 1px solid var(--chaek-color-text-secondary);
  border-radius: 50%;
  content: '';
}

.Radio-module__input--B6HTm:checked + .Radio-module__indicator--Ektu7::before {
  width: var(--radio-checked-size);
  height: var(--radio-checked-size);
  border-radius: 50%;
  background-color: var(--radio-checked-color);
  content: '';
}

.Radio-module__input--B6HTm:focus-visible + .Radio-module__indicator--Ektu7 {
  outline: 2px solid var(--chaek-color-border-strong);
  outline-offset: 2px;
}

.Radio-module__root--n6qb3:has(.Radio-module__input--B6HTm:disabled) {
  cursor: not-allowed;
  opacity: 0.45;
}

.Radio-module__label--F01A6 {
  min-width: 0;
  flex: 1 1 auto;
  font: inherit;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Radio/Radio.module.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;EAC5B,0BAA0B;EAC1B,sDAAsD;;EAEtD,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;;EAE9B,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mDAAmD;EACnD,iDAAiD;EACjD,eAAe;EACf,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,SAAS;EACT,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,mCAAmC;EACnC,qCAAqC;EACrC,sCAAsC;EACtC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;EAClC,mCAAmC;EACnC,mDAAmD;EACnD,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,kBAAkB;EAClB,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;AACf","sourcesContent":[".root {\n  --radio-indicator-width: 22px;\n  --radio-indicator-height: 22px;\n  --radio-unchecked-size: 14px;\n  --radio-checked-size: 12px;\n  --radio-checked-color: var(--chaek-color-text-primary);\n\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--chaek-color-text-primary);\n  cursor: pointer;\n}\n\n.variant-accent {\n  --radio-checked-color: var(--chaek-color-text-accent);\n}\n\n.size-large {\n  --radio-unchecked-size: 22px;\n  --radio-checked-size: 22px;\n}\n\n.is-boxed {\n  --radio-indicator-width: 24px;\n  --radio-indicator-height: 30px;\n\n  box-sizing: border-box;\n  height: 50px;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px 16px;\n  border-radius: 15px;\n  background-color: var(--chaek-color-surface-subtle);\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-size: 14px;\n  line-height: 21px;\n  letter-spacing: -0.150390625px;\n}\n\n.is-boxed + .is-boxed {\n  margin-top: 16px;\n}\n\n.is-block {\n  display: flex;\n}\n\n.input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  border: 0;\n  margin: -1px;\n  clip: rect(0, 0, 0, 0);\n  clip-path: inset(50%);\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.indicator {\n  position: relative;\n  box-sizing: border-box;\n  display: inline-flex;\n  width: var(--radio-indicator-width);\n  height: var(--radio-indicator-height);\n  flex: 0 0 var(--radio-indicator-width);\n  align-items: center;\n  justify-content: center;\n}\n\n.input:not(:checked) + .indicator::before {\n  box-sizing: border-box;\n  width: var(--radio-unchecked-size);\n  height: var(--radio-unchecked-size);\n  border: 1px solid var(--chaek-color-text-secondary);\n  border-radius: 50%;\n  content: '';\n}\n\n.input:checked + .indicator::before {\n  width: var(--radio-checked-size);\n  height: var(--radio-checked-size);\n  border-radius: 50%;\n  background-color: var(--radio-checked-color);\n  content: '';\n}\n\n.input:focus-visible + .indicator {\n  outline: 2px solid var(--chaek-color-border-strong);\n  outline-offset: 2px;\n}\n\n.root:has(.input:disabled) {\n  cursor: not-allowed;\n  opacity: 0.45;\n}\n\n.label {\n  min-width: 0;\n  flex: 1 1 auto;\n  font: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Radio-module__root--n6qb3`,
	"variant-accent": `Radio-module__variant-accent--f4ULR`,
	"size-large": `Radio-module__size-large--crMnS`,
	"is-boxed": `Radio-module__is-boxed--hYNih`,
	"is-block": `Radio-module__is-block--Dkab7`,
	"input": `Radio-module__input--B6HTm`,
	"indicator": `Radio-module__indicator--Ektu7`,
	"label": `Radio-module__label--F01A6`
};
export default ___CSS_LOADER_EXPORT___;
